import { c as _c } from "react/compiler-runtime";
import { IconCarambola, IconTag, IconTrophy } from "@tabler/icons-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { TypeProduct } from "@/types/contentful/generated";
export type ProductFlagValue = NonNullable<TypeProduct<undefined, string>["fields"]["plpFlag"]>;
interface Props {
  flag?: ProductFlagValue;
  className?: string;
}
const variantMap: Record<ProductFlagValue, {
  Icon: typeof IconTrophy;
  color: string;
}> = {
  "Best Seller": {
    Icon: IconTrophy,
    color: "bg-primary"
  },
  New: {
    Icon: IconCarambola,
    color: "bg-secondary-brand"
  },
  Sale: {
    Icon: IconTag,
    color: "bg-green-600"
  }
};
function isProductFlag(value: string): value is ProductFlagValue {
  return value in variantMap;
}

// The PDP passes the generated union straight through, but the PLP reads the
// flag off a Typesense document as a plain string. Narrow there: variantMap has
// no entry for an unknown value, so rendering one would destructure undefined.
export function toProductFlag(value: string | undefined): ProductFlagValue | undefined {
  if (!value) return undefined;
  return isProductFlag(value) ? value : undefined;
}
export function ProductFlag(t0) {
  const $ = _c(9);
  const {
    flag,
    className
  } = t0;
  if (!flag) {
    return null;
  }
  const {
    Icon,
    color
  } = variantMap[flag];
  let t1;
  if ($[0] !== className || $[1] !== color) {
    t1 = cn("font-semibold text-primary-foreground", color, className);
    $[0] = className;
    $[1] = color;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== Icon) {
    t2 = <Icon size={12} aria-hidden={true} />;
    $[3] = Icon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== flag || $[6] !== t1 || $[7] !== t2) {
    t3 = <Badge className={t1}>{t2}{flag}</Badge>;
    $[5] = flag;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}